// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_XSNPZ","weChat":"index_weChat_0TFN5","weChatIcon":"index_weChatIcon_TsHLt","friends":"index_friends_AmFqd","friendsIcon":"index_friendsIcon_iCk-1"};